import { render } from "./DefaultCardContainer.vue?vue&type=template&id=686ea9eb&ts=true"
import script from "./DefaultCardContainer.vue?vue&type=script&lang=ts"
export * from "./DefaultCardContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__